import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from '../../../../services/loader.service';

@Component({
  selector: 'mcb-loader',
  templateUrl: './loader.component.html'
})
export class PortalLoaderComponent implements OnInit {
  isLoading: Subject<boolean> = this.loaderService.isLoading;
  constructor(private loaderService: LoaderService) {
  }

  ngOnInit() {
    // this.loadingService.onLoadingSpinner.subscribe(showLoading => {
    //   this.showLoading = showLoading;
    // });
  }
}
